// 📁 hooks/useCategoriaState.js
import { useState } from "react";

export const useCategoriaState = () => {
  const [selectedAsociacion, setSelectedAsociacion] = useState(null);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [expandedCategorias, setExpandedCategorias] = useState({});
  const [expandedGubernamental, setExpandedGubernamental] = useState(false);
  const [vistaJuntaDirectiva, setVistaJuntaDirectiva] = useState('lista');
  const [openModal, setOpenModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  const handleSelectAsociacion = (asociacion) => {
    setSelectedAsociacion(asociacion);
    // Reset expanded categories when changing association
    setExpandedCategorias({});
  };

  const handleToggleCategoria = (asociacionId, categoriaId) => {
    const key = `${asociacionId}-${categoriaId}`;
    setExpandedCategorias(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleOpenModal = (categoria) => {
    setSelectedCategoria(categoria);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedCategoria(null);
  };

  const handleVistaJuntaChange = (event, newVista) => {
    if (newVista !== null) {
      setVistaJuntaDirectiva(newVista);
    }
  };

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const hideSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return {
    // State
    selectedAsociacion,
    selectedCategoria,
    expandedCategorias,
    expandedGubernamental,
    vistaJuntaDirectiva,
    openModal,
    drawerOpen,
    snackbar,
    
    // Setters
    setSelectedAsociacion,
    setExpandedGubernamental,
    setVistaJuntaDirectiva,
    setDrawerOpen,
    
    // Handlers
    handleSelectAsociacion,
    handleToggleCategoria,
    handleOpenModal,
    handleCloseModal,
    handleVistaJuntaChange,
    showSnackbar,
    hideSnackbar
  };
};